import { create } from "zustand";

export default  create((set) => ({
  isLoading: true,
  setIsLoading: (isLoding: boolean) => set(() => ({ isLoding: isLoding })),

  homeModules: [],
  setHomeModules: (homeModule: any) => set(() => ({ homeModule: homeModule })),
}))
